<footer class="p-6 md:p-20">
  <div
    class="max-w-[78rem] mx-auto my-0 text-white flex flex-col items-center gap-6 md:gap-[2.5rem]"
  >
    <div
      class="flex md:flex-row md:justify-between flex-col md:gap-0 w-full divide-y md:divide-y-0 divide-white/20"
    >
      <div class="flex-1">
        <div class="flex max-w-[80%] flex-col gap-5 md:block hidden">
          <h4 class="!text-[1rem]">
            {{"footer.summaries.development.title" | transloco}}
          </h4>
          <div class="flex flex-col gap-2">
            <a
              [routerLink]="'/development'"
              fragment="develop-myself"
              class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
              >{{"footer.summaries.development.developMyself" | transloco}}</a
            >
            <a
              [routerLink]="'/development'"
              fragment="better-know-myself"
              class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
              >{{"footer.summaries.development.betterKnowMyself" |
              transloco}}</a
            >
          </div>
        </div>
      </div>
      <details class="md:hidden py-4">
        <summary
          class="flex items-center justify-between cursor-pointer list-none"
        >
          <h4 class="!text-[1rem]">
            {{"footer.summaries.development.title" | transloco}}
          </h4>
          <icon
            [name]="'nav-arrow-down'"
            [size]="'0.875rem'"
            class="icon-closed mb-4"
          />
          <icon
            [name]="'nav-arrow-up'"
            [size]="'0.875rem'"
            class="icon-open mb-4"
          />
        </summary>
        <div class="flex flex-col gap-2 mt-4">
          <a
            [routerLink]="'/development'"
            fragment="develop-myself"
            class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
            >{{"footer.summaries.development.developMyself" | transloco}}</a
          >
          <a
            [routerLink]="'/development'"
            fragment="better-know-myself"
            class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
            >{{"footer.summaries.development.betterKnowMyself" | transloco}}</a
          >
        </div>
      </details>

      <div class="flex-1">
        <div class="max-w-[80%] flex flex-col gap-5 md:block hidden">
          <h4 class="!text-[1rem]">
            {{"footer.summaries.mobility.title" | transloco}}
          </h4>
          <div class="flex flex-col gap-2">
            <a
              [routerLink]="'/mobility'"
              fragment="discover-our-jobs"
              class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
              >{{"footer.summaries.mobility.discoverOurJobs" | transloco}}</a
            >
            <a
              [routerLink]="'/mobility'"
              fragment="mobility-project-exchange"
              class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
              >{{"footer.summaries.mobility.mobilityProjectExchange" |
              transloco}}</a
            >
            <a
              [routerLink]="'/mobility'"
              fragment="mobility-offer-application"
              class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
              >{{"footer.summaries.mobility.mobilityOfferApplication" |
              transloco}}</a
            >
          </div>
        </div>
      </div>
      <details class="md:hidden py-4">
        <summary
          class="flex items-center justify-between cursor-pointer list-none"
        >
          <h4 class="!text-[1rem]">
            {{"footer.summaries.mobility.title" | transloco}}
          </h4>
          <icon
            [name]="'nav-arrow-down'"
            [size]="'0.875rem'"
            class="icon-closed mb-4"
          />
          <icon
            [name]="'nav-arrow-up'"
            [size]="'0.875rem'"
            class="icon-open mb-4"
          />
        </summary>
        <div class="flex flex-col gap-2 mt-4">
          <a
            [routerLink]="'/mobility'"
            fragment="discover-our-jobs"
            class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
            >{{"footer.summaries.mobility.discoverOurJobs" | transloco}}</a
          >
          <a
            [routerLink]="'/mobility'"
            fragment="mobility-project-exchange"
            class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
            >{{"footer.summaries.mobility.mobilityProjectExchange" |
            transloco}}</a
          >
          <a
            [routerLink]="'/mobility'"
            fragment="mobility-offer-application"
            class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
            >{{"footer.summaries.mobility.mobilityOfferApplication" |
            transloco}}</a
          >
        </div>
      </details>

      <div class="flex-1">
        <div class="max-w-[80%] flex flex-col gap-5 md:block hidden">
          <h4 class="!text-[1rem]">
            {{"footer.summaries.personalizedJourney.title" | transloco}}
          </h4>
          <div class="flex flex-col gap-2">
            <a
              [routerLink]="'/journey'"
              class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
              >{{"footer.summaries.personalizedJourney.myPersonalizedJourney" |
              transloco}}</a
            >
          </div>
        </div>
      </div>
      <details class="md:hidden py-4">
        <summary
          class="flex items-center justify-between cursor-pointer list-none"
        >
          <h4 class="!text-[1rem]">
            {{"footer.summaries.personalizedJourney.title" | transloco}}
          </h4>
          <icon
            [name]="'nav-arrow-down'"
            [size]="'0.875rem'"
            class="icon-closed mb-4"
          />
          <icon
            [name]="'nav-arrow-up'"
            [size]="'0.875rem'"
            class="icon-open mb-4"
          />
        </summary>
        <div class="flex flex-col gap-2 mt-4">
          <a
            [routerLink]="'/journey'"
            class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
            >{{"footer.summaries.personalizedJourney.myPersonalizedJourney" |
            transloco}}</a
          >
        </div>
      </details>

      <div class="flex-1">
        <div class="max-w-[80%] flex flex-col gap-5 md:block hidden">
          <h4 class="!text-[1rem]">
            {{"footer.summaries.profile.title" | transloco}}
          </h4>
          <div class="flex flex-col gap-2">
            <a
              [routerLink]="'/user-profile'"
              class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
              >{{"footer.summaries.profile.myDashboard" | transloco}}</a
            >
            <a
              [routerLink]="'/user-profile/portal-questionnaire'"
              class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
              >{{"footer.summaries.profile.mobilityQuestionnaire" |
              transloco}}</a
            >
            <a
              [routerLink]="'/user-profile/documents'"
              class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
              >{{"footer.summaries.profile.myDocuments" | transloco}}</a
            >
            <a
              [routerLink]="'/user-profile/feedback'"
              class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
              >{{"footer.summaries.profile.leaveAFeedback" | transloco}}</a
            >
            <a
              [routerLink]="'/user-profile/faq'"
              class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
              >{{"footer.summaries.profile.faq" | transloco}}</a
            >
          </div>
        </div>
      </div>
      <details class="md:hidden py-4">
        <summary
          class="flex items-center justify-between cursor-pointer list-none"
        >
          <h4 class="!text-[1rem]">
            {{"footer.summaries.profile.title" | transloco}}
          </h4>
          <icon
            [name]="'nav-arrow-down'"
            [size]="'0.875rem'"
            class="icon-closed mb-4"
          />
          <icon
            [name]="'nav-arrow-up'"
            [size]="'0.875rem'"
            class="icon-open mb-4"
          />
        </summary>
        <div class="flex flex-col gap-2 mt-4">
          <a
            [routerLink]="'/user-profile'"
            class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
            >{{"footer.summaries.profile.myDashboard" | transloco}}</a
          >
          <a
            [routerLink]="'/user-profile/portal-questionnaire'"
            class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
            >{{"footer.summaries.profile.mobilityQuestionnaire" | transloco}}</a
          >
          <a
            [routerLink]="'/user-profile/documents'"
            class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
            >{{"footer.summaries.profile.myDocuments" | transloco}}</a
          >
          <a
            [routerLink]="'/user-profile/feedback'"
            class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
            >{{"footer.summaries.profile.leaveAFeedback" | transloco}}</a
          >
          <a
            [routerLink]="'/user-profile/faq'"
            class="font-light hover:underline transition-all duration-200 !text-[0.875rem]"
            >{{"footer.summaries.profile.faq" | transloco}}</a
          >
        </div>
      </details>

      <a
        [routerLink]="'/'"
        class="self-center rounded-lg bg-vinciBlue-600 md:block hidden"
      >
        <img
          src="assets/images/vinci-construction-white.svg"
          alt="Logo Vinci Construction Blanc"
          class="w-[13.75rem] h-[5.6875rem]"
        />
      </a>
    </div>
    <a
      [routerLink]="'/'"
      class="self-center rounded-lg bg-vinciBlue-600 md:hidden mt-4"
    >
      <img
        src="assets/images/vinci-construction-white.svg"
        alt="Logo Vinci Construction Blanc"
        class="w-[13.75rem] h-[5.6875rem]"
      />
    </a>
  </div>
</footer>
